export default __webpack_public_path__ + "static/yanagi-7c4136080a5ce186c9c8d29716fcba9d.jpeg";